import { Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { Card, Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { create, updateAction } from "../../../store/actions/CommonActions";
import ArtistForm from "../Forms/ArtistForm";
import { apiCaller } from "../../../services/AxiosInstance";
import { toast } from "react-toastify";

export const uploadFileToServer = async (file) => {
    // 🔍 upload file to server and return the uploaded file url
    const formData = new FormData();
    formData.append("file", file);
    try {
        const res = await apiCaller({
            method: "post",
            url: "upload",
            params: null,
            data: formData,
        });
        if (res?.data?.data?.url) {
            return res?.data?.data?.url;
        } else {
            throw new Error("Upload failed");
        }
    } catch (err) {
        throw err;
        console.error(err);
        // alert("Error uploading file");
    }
}

export const removeImageFromPath = async (oldValue) => {
    try {
        const res = await apiCaller({
            method: "post",
            url: "remove-image",
            params: null,
            data: { key: oldValue },
        });
        if (res) {
            // setFileName("");
            // setFilePath("");
            // setFieldValue(fieldName, "");
        }
    } catch (err) {
        console.error(err);
        // alert("Error uploading file");
    }
}

const FormHandler = ({ modalConfig }) => {
    // const closeModal = setShow(false);
    const {
        validationSchema,
        apiUrl,
        closeModal,
        FormComponent,
        updateTitle,
        addTitle,
        showModal,
        extraProps,
        subTitle,
        handleSubmit,
    } = modalConfig;
    const [relationData, setRelationData] = useState({});
    const dispatch = useDispatch();
    const [initialValues, setInitialValues] = useState(
        modalConfig?.initialValues ?? {}
    );
    useEffect(() => {
        if (extraProps && extraProps.relationKeys) {
            let relationElementsData = {};
            let tmpInitialValues = { ...modalConfig.initialValues };
            extraProps.relationKeys.forEach((relationItem) => {
                if (tmpInitialValues[relationItem]) {
                    relationElementsData[relationItem] = {
                        ...tmpInitialValues[relationItem],
                    };
                }
                tmpInitialValues[relationItem] = tmpInitialValues[relationItem]._id;
            });
            setInitialValues(tmpInitialValues);
            setRelationData(relationElementsData);
        }
    }, [extraProps]);

    const handleFormSubmit = async (values, { setSubmitting, setFieldError, setFieldValue }) => {
        try {
            // setSubmitting(true);
            const keysToCheck = ["profile_image", "cover_image", "bannerImage", "banner", "supportingMaterialPdf"];

            for (const [key, value] of Object.entries(values)) {
                try {
                    if (keysToCheck.findIndex((k) => k === key) !== -1) {
                        const oldValue = initialValues[key];
                        const newValue = values[key];

                        // If old had a value, new is empty/null → remove from server
                        if (oldValue && !newValue) {
                            console.log("Removed:", key, "old path:", oldValue);
                            // Call your API here
                            await removeImageFromPath(oldValue);
                        }
                    }
                } catch (error) {
                    toast.error("Error removing file");
                    console.error(error);
                    setSubmitting(false);
                    return;
                }
                if (value instanceof File) {
                    const file = value;
                    try {
                        // 🔍 upload file
                        const url = await uploadFileToServer(file);
                        // console.log('svnioevs', url);
                        values[key] = url;
                    } catch (err) {
                        toast.error("Error uploading file");
                        console.error(err);
                        setSubmitting(false);
                        return; // stop submit
                    }
                }
            }
            if (values?.referenceLinks && Array.isArray(values?.referenceLinks)) {
                let tmpReferenceLinks = [];
                values?.referenceLinks.forEach((link) => {
                    if (link) tmpReferenceLinks.push(link);
                });
                values.referenceLinks = tmpReferenceLinks;
            }
            let responseData;
            if (initialValues._id) {
                responseData = await apiCaller({
                    method: "put",
                    data: {
                        ...values,
                        show: initialValues?.show ?? null
                    },
                    url: `${apiUrl}/${initialValues._id}`
                });
                // await updateAction(`${apiUrl}/${initialValues._id}`, "", {
                //     ...values,
                //     show: initialValues?.show ?? null,
                // })
            } else {
                responseData = await apiCaller({
                    method: "post",
                    data: {
                        ...values,
                        show: initialValues?.show ?? null
                    },
                    url: `${apiUrl}`
                });
                // console.log('svnioevs', responseData);
            }
            const saveOk =
                responseData?.data?.success === true ||
                responseData?.status === 200 ||
                responseData?.status === 201;
            if (saveOk) {
                if (closeModal) closeModal();
                if (handleSubmit) handleSubmit();
            }
            setSubmitting(false);
        } catch (error) { }
    };
    return (
        <Card
            className="pb-3"
            id="formHandler"
            style={{ height: "auto" }}
            show={showModal ?? true}
            onHide={(e) => closeModal(e) ?? null}
        >
            <ArtistForm
                initialValues={initialValues}
                validationSchema={validationSchema}
                handleFormSubmit={handleFormSubmit}
                closeModal={closeModal}
                FormComponent={FormComponent}
                relationData={relationData}
                updateTitle={updateTitle}
                addTitle={addTitle}
                subTitle={subTitle}
                extraProps={extraProps}
            />
        </Card>
    );
};

export default FormHandler;
